module.exports = __webpack_public_path__ + "static/bg-landing-ve-mobile-ed0c9b595e99289a0c6e5ad381678f76.svg";